/**
 * Owner-webview signal from the frame reducer to the connection-health host.
 * Each webview is its own JS context, so mirror reducers reach no listener.
 */
type Listener = (runtimeType?: string) => void;
type RecoveredListener = (runtimeType: string, startedAt: number) => void;

const listeners = new Set<Listener>();
const recoveredListeners = new Set<RecoveredListener>();

export function reportRuntimeAuthRecovered(
  runtimeType: string,
  startedAt: number,
): void {
  for (const listener of recoveredListeners) listener(runtimeType, startedAt);
}

export function subscribeRuntimeAuthRecovered(
  listener: RecoveredListener,
): () => void {
  recoveredListeners.add(listener);
  return () => {
    recoveredListeners.delete(listener);
  };
}

export function reportRuntimeAuthRequired(runtimeType?: string): void {
  for (const listener of listeners) listener(runtimeType);
}

export function subscribeRuntimeAuthRequired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
